import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import UiAlertConfirmationModal from 'components/Ui/UiAlertConfirmationModal'
import { closeSecondaryModal, openSecondaryModal } from 'helpers/actions'
import { useAppDispatch } from 'helpers/store'
import { ModalSize } from 'types/enums/ModalSize'
import { UiButtonStyle } from 'components/Ui/UiButton'

interface OpenSecondaryConfirmModalParams {
    title: string
    message: string | React.ReactNode
    onConfirm: () => void | Promise<void>
    onCancel?: () => void
    confirmLabel?: string
    cancelLabel?: string
    confirmStyle?: UiButtonStyle
    isSubmitting?: boolean
    modalSize?: ModalSize
    modalTitle?: string
}

export const useSecondaryConfirmModal = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    return useCallback(
        ({
            title,
            message,
            onConfirm,
            onCancel,
            confirmLabel,
            cancelLabel,
            confirmStyle,
            isSubmitting,
            modalSize = ModalSize.Small,
            modalTitle,
        }: OpenSecondaryConfirmModalParams) => {
            const handleClose = () => dispatch(closeSecondaryModal())
            const handleCancel = () => {
                if (onCancel) {
                    onCancel()
                    return
                }
                handleClose()
            }

            dispatch(
                openSecondaryModal(
                    <UiAlertConfirmationModal
                        title={title}
                        message={message}
                        onConfirm={onConfirm}
                        onCancel={handleCancel}
                        confirmLabel={confirmLabel}
                        cancelLabel={cancelLabel}
                        confirmStyle={confirmStyle}
                        isSubmitting={isSubmitting}
                    />,
                    {
                        modalSize,
                        closeModal: handleClose,
                    },
                    modalTitle || t('Confirm')
                )
            )
        },
        [dispatch, t]
    )
}
